export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10579.bf070469.jpg";